(function () {
  function initNewProduct(section) {
    if (!section || section.dataset.newProductInit === 'true') return;
    section.dataset.newProductInit = 'true';

    var mediaItems = section.querySelectorAll('[data-new-product-media]');
    var thumbs = section.querySelectorAll('[data-new-product-thumb]');
    var dots = section.querySelectorAll('[data-new-product-dot]');
    var frame = section.querySelector('[data-new-product-frame]');
    var gallery = section.querySelector('.new-product__media');
    var thumbsContainer = section.querySelector('[data-new-product-thumbs-container]');
    var thumbsList = section.querySelector('[data-new-product-thumbs]');
    var thumbsPrev = section.querySelector('[data-new-product-thumbs-prev]');
    var thumbsNext = section.querySelector('[data-new-product-thumbs-next]');
    var qtyInput = section.querySelector('[data-new-product-qty]');
    var stickyQtyInput = section.querySelector('[data-new-product-sticky-qty]');
    var minus = section.querySelector('[data-new-product-minus]');
    var plus = section.querySelector('[data-new-product-plus]');
    var priceTargets = section.querySelectorAll('[data-new-product-price]');
    var comparePriceTargets = section.querySelectorAll('[data-new-product-compare-price]');
    var paymentTerms = section.querySelector('shopify-payment-terms');
    var basePrice = parseInt(section.dataset.basePrice || '0', 10);
    var baseCompareAtPrice = parseInt(section.dataset.baseCompareAtPrice || '0', 10);
    var currency = section.dataset.currency || 'USD';

    section.querySelectorAll('[data-new-product-tabs]').forEach(function (tabsComponent) {
      var tabButtons = Array.from(tabsComponent.querySelectorAll('[data-new-product-tab]'));
      var tabPanels = Array.from(tabsComponent.querySelectorAll('[data-new-product-panel]'));

      function activateTab(tabName, moveFocus) {
        tabButtons.forEach(function (button) {
          var active = button.dataset.newProductTab === tabName;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
          button.tabIndex = active ? 0 : -1;
          if (active && moveFocus) button.focus();
        });

        tabPanels.forEach(function (panel) {
          var active = panel.dataset.newProductPanel === tabName;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;

          if (!active) {
            panel.querySelectorAll('video').forEach(function (video) {
              video.pause();
            });
          }
        });
      }

      tabButtons.forEach(function (button, index) {
        button.addEventListener('click', function () {
          activateTab(button.dataset.newProductTab, false);
        });

        button.addEventListener('keydown', function (event) {
          var nextIndex;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabButtons.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabButtons.length) % tabButtons.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabButtons.length - 1;
          if (nextIndex === undefined) return;
          event.preventDefault();
          activateTab(tabButtons[nextIndex].dataset.newProductTab, true);
        });
      });
    });

    mediaItems.forEach(function (item, index) {
      item.style.setProperty('--np-slide-index', item.dataset.mediaIndex || index);
    });

    function updateNewSkalumGallery(item) {
      if (!frame || !gallery || !section.classList.contains('new-product--new-skalum') || !item) return;

      var aspectRatio = parseFloat(item.dataset.mediaAspectRatio || '');
      if (aspectRatio > 0) {
        frame.style.setProperty('--np-active-media-aspect-ratio', aspectRatio);

        if (window.innerWidth >= 768) {
          var galleryStyles = window.getComputedStyle(gallery);
          var gap = parseFloat(galleryStyles.columnGap || galleryStyles.gap || '0') || 0;
          var thumbsWidth = thumbsContainer ? thumbsContainer.getBoundingClientRect().width : 0;
          var availableImageWidth = gallery.clientWidth - thumbsWidth - (thumbsWidth > 0 ? gap : 0);
          var maxGalleryHeight = Math.min(800, window.innerHeight - 80);
          var galleryHeight = Math.min(maxGalleryHeight, availableImageWidth / aspectRatio);

          if (galleryHeight > 0) {
            gallery.style.setProperty('--np-gallery-height', galleryHeight + 'px');
          }
        } else {
          gallery.style.removeProperty('--np-gallery-height');
        }
      }
    }

    function updateActiveGallerySize() {
      updateNewSkalumGallery(section.querySelector('[data-new-product-media].is-active'));
    }

    updateActiveGallerySize();
    window.addEventListener('resize', updateActiveGallerySize);

    function pauseVideos() {
      section.querySelectorAll('[data-new-product-media] video').forEach(function (video) {
        video.pause();
      });
    }

    function activateMedia(mediaId) {
      pauseVideos();
      var activeIndex = 0;

      thumbs.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
      });

      dots.forEach(function (dot) {
        var active = dot.dataset.mediaId === mediaId;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      mediaItems.forEach(function (item) {
        var active = item.dataset.mediaId === mediaId;
        item.classList.toggle('is-active', active);
        if (active) {
          activeIndex = parseInt(item.dataset.mediaIndex || '0', 10) || 0;
        }
      });

      if (frame) {
        frame.style.setProperty('--np-active-index', activeIndex);
      }

      var activeItem = section.querySelector('[data-new-product-media][data-media-id="' + mediaId + '"]');
      updateNewSkalumGallery(activeItem);
      var video = activeItem ? activeItem.querySelector('video') : null;
      if (video) {
        video.muted = true;
        video.play().catch(function () {});
      }
    }

    function activateByIndex(index) {
      if (!mediaItems.length) return;
      var nextIndex = (index + mediaItems.length) % mediaItems.length;
      activateMedia(mediaItems[nextIndex].dataset.mediaId);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(thumb.dataset.mediaId);
      });
    });

    function updateThumbsOverflow() {
      if (!thumbsContainer || !thumbsList || !thumbsPrev || !thumbsNext) return;

      var isDesktop = window.innerWidth >= 768;
      var isScrollable = isDesktop && thumbsList.scrollHeight > thumbsList.clientHeight + 1;
      var hasScrolled = isScrollable && thumbsList.scrollTop > 1;
      var isAtEnd = !isScrollable || thumbsList.scrollTop + thumbsList.clientHeight >= thumbsList.scrollHeight - 1;

      thumbsContainer.classList.toggle('is-scrollable', isScrollable);
      thumbsContainer.classList.toggle('has-scrolled', hasScrolled);
      thumbsContainer.classList.toggle('is-at-end', isAtEnd);
      thumbsPrev.hidden = !isScrollable;
      thumbsNext.hidden = !isScrollable;
    }

    if (thumbsList && thumbsPrev && thumbsNext) {
      thumbsPrev.addEventListener('click', function () {
        thumbsList.scrollBy({ top: -216, behavior: 'smooth' });
      });
      thumbsNext.addEventListener('click', function () {
        thumbsList.scrollBy({ top: 216, behavior: 'smooth' });
      });
      thumbsList.addEventListener('scroll', updateThumbsOverflow, { passive: true });
      window.addEventListener('resize', updateThumbsOverflow);

      if (window.ResizeObserver) {
        new ResizeObserver(updateThumbsOverflow).observe(thumbsList);
      }

      window.requestAnimationFrame(updateThumbsOverflow);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        activateMedia(dot.dataset.mediaId);
      });
    });

    if (frame && mediaItems.length > 1) {
      var touchStartX = 0;

      frame.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });

      frame.addEventListener('touchend', function (event) {
        var deltaX = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(deltaX) < 40) return;

        var active = section.querySelector('[data-new-product-media].is-active');
        var activeIndex = active ? parseInt(active.dataset.mediaIndex || '0', 10) : 0;
        activateByIndex(deltaX < 0 ? activeIndex + 1 : activeIndex - 1);
      }, { passive: true });
    }

    function formatMoney(cents) {
      var options = { style: 'currency', currency: currency };
      if (cents % 100 === 0) {
        options.minimumFractionDigits = 0;
        options.maximumFractionDigits = 0;
      }
      return (cents / 100).toLocaleString('en-US', options);
    }

    function updateQuantity() {
      if (!qtyInput) return;
      var quantity = parseInt(qtyInput.value || '1', 10);
      if (quantity < 1) quantity = 1;
      qtyInput.value = quantity;
      if (stickyQtyInput) stickyQtyInput.value = quantity;

      if (basePrice > 0) {
        priceTargets.forEach(function (target) {
          target.textContent = formatMoney(basePrice * quantity);
        });
      }

      if (baseCompareAtPrice > basePrice) {
        comparePriceTargets.forEach(function (target) {
          target.textContent = formatMoney(baseCompareAtPrice * quantity);
        });
      }
    }

    if (minus && plus && qtyInput) {
      minus.addEventListener('click', function () {
        var value = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = Math.max(1, value - 1);
        updateQuantity();
      });

      plus.addEventListener('click', function () {
        var value = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = value + 1;
        updateQuantity();
      });

      qtyInput.addEventListener('change', updateQuantity);
      updateQuantity();
    }

    function stylePaymentTerms() {
      if (!paymentTerms || !paymentTerms.shadowRoot) return;
      if (paymentTerms.shadowRoot.querySelector('[data-new-product-payment-style]')) return;

      var style = document.createElement('style');
      style.dataset.newProductPaymentStyle = 'true';
      style.textContent = [
        ':host { display: block; }',
        '#shopify-installments-content { color: #2a2c69; font-family: "Body Text", Arial, sans-serif; font-size: 14px; line-height: 18px; letter-spacing: 0; }',
        '#shopify-installments-content span, #shopify-installments-content p { color: inherit; font: inherit; letter-spacing: inherit; }',
        '#shopify-installments-content .shop-pay-logo, #shopify-installments-content svg { color: #2a2c69; fill: #2a2c69; }',
        '#shopify-installments-content button { margin: 0; padding: 0; border: 0; background: transparent; color: #2a2c69; font: inherit; letter-spacing: inherit; text-decoration: none; cursor: pointer; }'
      ].join('');
      paymentTerms.shadowRoot.appendChild(style);
    }

    if (paymentTerms) {
      [0, 150, 500, 1000, 2000].forEach(function (delay) {
        window.setTimeout(function () {
          stylePaymentTerms();
        }, delay);
      });
    }

    var stickyBar = section.querySelector('[data-new-product-sticky]');
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');

    function updateSticky() {
      if (!stickyBar || window.innerWidth >= 768) return;
      if (!footer) {
        stickyBar.classList.remove('is-hidden');
        return;
      }

      var footerRect = footer.getBoundingClientRect();
      stickyBar.classList.toggle('is-hidden', footerRect.top <= window.innerHeight);
    }

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();

    var mainForm = section.querySelector('.new-product__form');
    var stickyForm = section.querySelector('.new-product__sticky-form');
    if (mainForm && stickyForm) {
      function syncSellingPlan() {
        var existingPlan = stickyForm.querySelector('input[name="selling_plan"]');
        if (existingPlan) existingPlan.remove();

        var mainPlan = mainForm.querySelector('input[name="selling_plan"]');
        if (mainPlan && mainPlan.value) {
          var clone = document.createElement('input');
          clone.type = 'hidden';
          clone.name = 'selling_plan';
          clone.value = mainPlan.value;
          stickyForm.appendChild(clone);
        }
      }

      new MutationObserver(syncSellingPlan).observe(mainForm, {
        childList: true,
        subtree: true,
        attributes: true
      });

      document.addEventListener('change', function (event) {
        if (event.target.name === 'purchaseOption' || event.target.name === 'selling_plan') {
          setTimeout(syncSellingPlan, 100);
        }
      });

      syncSellingPlan();
    }
  }

  function initAll() {
    document.querySelectorAll('[data-new-product-section]').forEach(initNewProduct);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initNewProduct(event.target.querySelector('[data-new-product-section]'));
  });
})();
